<div class="submit-dialog">

  <!-- Header -->
  <div class="dialog-header">

    <div class="header-left">

      <div class="warning-icon">
        <mat-icon>warning_amber</mat-icon>
      </div>

      <div>
        <h2> Review Changes</h2>

        <p>
          The following declarations differ from your previous submission.
        </p>
      </div>
      

    </div>

    <div class="dialog-legend">
      <div class="legend-item">
        <span class="old-answer">Old Value</span>
        <!-- <span class="legend-desc">Your previously saved answer</span> -->
      </div>
      <div class="legend-item">
        <span class="new-answer">New Value</span>
        <!-- <span class="legend-desc">The answer you just changed it to</span> -->
      </div>
    </div>

  </div>

  <!-- Changed Questions -->
  <div class="changes-list">
    <h2 mat-dialog-title>
      <span class="highlight-section">{{ getFormattedSectionName(data.sectionName) }}</span>
    </h2>

  @for (item of data.changedQuestions; track item; let i = $index) {

  <div class="change-item">

    <div class="question-number">
    {{ item.questionNo }}
    </div>

    <div class="question-content">

      <p class="question-text">
       {{ getDisplayQuestionText(item.questionText) }}
      </p>

      <div class="answer-change">

        <span 
          class="old-answer"
          [ngClass]="{'new-indicator': (item.oldValue === '' || item.oldValue === null)}"
        >
          {{ (item.oldValue === '' || item.oldValue === null) ? 'New' : item.oldValue }}
        </span>

        <mat-icon>
          arrow_forward
        </mat-icon>

        <span class="new-answer">
        @if (item.newValue === 'False') {
        <span>No</span>
      } @else if (item.newValue === 'True') {
        <span>Yes</span>
      } @else {
        <span>{{ item.newValue }}</span>
      }
        </span>

      </div>

    </div>

  </div>

}

  </div>

  <!-- Footer -->
  <div class="dialog-footer">

    <button
    type="button"
      mat-stroked-button
      (click)="cancel()"
    >
      Cancel
    </button>

    <button
    type="button"
      mat-flat-button
      color="primary"
      (click)="confirmSubmit()"
    >
      Confirm & Save
    </button>

  </div>

</div>